import { AdapterFactory } from './adapter-factory';

export const CheckedItemAdapter = AdapterFactory({ convertEventToValue: event => event.target.checked, defaultValue: false, valueToInject: 'checked' });
